import React, { PureComponent } from 'react';
import './Loader.scss';

interface OwnProps {
    show: boolean;
    overlay?: boolean;
    children?: JSX.Element[];
}

export class Loader extends PureComponent<OwnProps> {
    render(): JSX.Element | null {
        const { show, overlay } = this.props;

        if (!show) {
            return null;
        }

        return (
            <>
                {overlay
                    ? <div className='basket-loader__overlay'>
                        {this.renderLoader()}
                    </div>
                    : this.renderLoader()
                }
            </>
        );
    }

    renderLoader(): JSX.Element {
        const { children } = this.props;

        return (
            <div className='basket-loader'>
                {children}
            </div>
        );
    }
}